//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {STATUSSES} from '~/plugins/constants';

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatus(status) {
      return STATUSSES[status] ? STATUSSES[status] : 'Onbekend';
    },
  },
};
